import React from 'react';
import { Link } from 'react-router-dom';
// import { TbError404 } from "react-icons/tb";
import Error from '../images/404 Error-rafiki.svg';

const ErrorPage = () => {
	return (
		<div className=' flex justify-center items-center h-screen flex-col'>
			<div className=' flex justify-center items-center mb-10 w-[500px] flex-col'>
				{/* <TbError404 className=' text-[72px] text-red-600'/> */}
				<img src={Error} alt='' className='' />
				<p className=' text-xl text-red-600 uppercase font-bold'>page not found </p>
			</div>

			<Link to={'/dashboard'} className=' proBtn'>
				go to dashboard
			</Link>
		</div>
	);
};

export default ErrorPage;
